import { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const HeroSlider = ({ pageType = "home" }) => {
    const [slides, setSlides] = useState([]);
    const [isMobile, setIsMobile] = useState(
        window.innerWidth <= 768
    );
    const API_URL = process.env.REACT_APP_BKND_URL;
    /*
    |--------------------------------------------------------------------------
    | Detect Mobile Screen
    |--------------------------------------------------------------------------
    */
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    /*
    |--------------------------------------------------------------------------
    | Fetch Sliders
    |--------------------------------------------------------------------------
    */
    useEffect(() => {
        const deviceType = isMobile ? "mobile" : "desktop";
        fetch(`${API_URL}/get-sliders.php?page_type=${pageType}&device_type=${deviceType}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status) {
                    setSlides(data.data);
                }
            })
            .catch((error) => {
                console.log(
                    "Slider API Error:",
                    error
                );
            });
    }, [pageType, isMobile, API_URL]);
    /*
    |--------------------------------------------------------------------------
    | Render
    |--------------------------------------------------------------------------
    */

    console.log("Slides", slides);
    
    if (!slides.length) {
        return null;
    }
    return (
        <Carousel
            autoPlay
            infiniteLoop
            showThumbs={false}
            showStatus={false}
            interval={8000}
            swipeable={!isMobile}
            emulateTouch={!isMobile}
            showIndicators={true}
            stopOnHover={false}
            dynamicHeight={false}
        >
            {slides.map((slide) => (
                <div key={slide.id} className="hero-slide">
                    <img
                        src={slide.image_url}
                        alt={slide.title}
                    />
                    {(slide.show_title || slide.show_subtitle || slide.show_title == 1 || slide.show_subtitle == 1) && (
                        <div className="hero-overlay">
                            {slide.show_title == 1 && (
                                <h2>{slide.title}</h2>
                            )}
                            {slide.show_subtitle == 1 && (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: slide.subtitle
                                    }}
                                />
                            )}
                        </div>
                    )}
                </div>
            ))}
        </Carousel>
    );
};
export default HeroSlider;